import React, {useState, useContext, useEffect} from 'react'
import { useHistory } from 'react-router-dom'
import {Col, Row, Table} from 'antd'
import { ColumnsType } from 'antd/es/table'
import {getAllOrderRequest} from '../../../../services/others/sales-order-dashboard-services'
import { ApiRequest } from '../../../../services/api/api'
import {baseUrl} from '../../../../services/api/base-url'
import { getCookie } from 'react-use-cookie'
import SalesOrderManagementPage from '../../../order/sales-order/sales-order-management-page'
import AwaitingDispatchList from '../../../../pages/warehouse/dispatch/dispatch-list/awaiting-dispatch-list'
import { getUserId } from '../../../../services/lib/utils/auth.utils'
import { normalizeTaskCommentDisplayType } from '../../../tasks/task-comment-utils'
import './dashboard.css';

interface User{
  order: string,
  status: string
}
const dataSend = React.createContext({})

// getallorder orderStatus

const tableForEmployee: ColumnsType<User> = [
  {
    key: 'customer',
    title: 'Customer',
    dataIndex: 'customer',
    width: 250
  }, {
    key: 'product',
    title: 'Product',
    dataIndex: 'product',
    render: (text, row, index) => {
      // console.log(text,row,index)
      return (
        <>
          {text.map((res:any, index:number) => {
            return (
              <div key={index}>
                <strong>Name</strong>:{res.name},
                <strong>Quantity</strong>:{res.quantity},
                <strong>Price</strong>:{res.price}
              </div>
            )
          })}
        </>
      )
    },
    width: 400
  }, {
    key: 'product',
    title: 'Options',
    dataIndex: 'option',
    render: (text, row, index) => {
      // console.log(text,row,index)
      return (
        <>
          {text.map((res:any, index:number) => {
            return (
              <div key={index}>
                <strong>Name</strong>:{res.optionName},
                <strong>Price</strong>:{res.price}
              </div>
            )
          })}
        </>
      )
    },
    width: 300
  }, {
    key: 'totalPrice',
    title: 'Total Price',
    dataIndex: 'totalPrice'
  }, {
    key: 'createdAt',
    title: 'Created At',
    dataIndex: 'createdAt'
  }, {
    key: 'requiredDate',
    title: 'Required Date',
    dataIndex: 'requiredDate'
  }
]

const stripReplyPrefixFromNotice = (text: string) =>
  String(text || '').replace(/^\s*\[reply\s+to\s+#\d+\]\s*/i, '').trim();

const extractReplyTargetIdFromNoticeContent = (content: string): string | null => {
  const m = String(content || '').match(/\[reply\s+to\s+#(\d+)\]/i);
  return m?.[1] ?? null;
};

const formatNoticeContext = (notice: any) => {
  if (!notice) {
    return '';
  }
  const normalizeNoticeType = (value: any, noticeContent?: string): string =>
    normalizeTaskCommentDisplayType(String(value ?? ""), noticeContent);
  const createdAt = notice.createdAt ? new Date(notice.createdAt) : null;
  const datePart = createdAt
    ? `${createdAt.getFullYear()}-${(createdAt.getMonth() + 1).toString().padStart(2, '0')}-${createdAt
        .getDate()
        .toString()
        .padStart(2, '0')} ${createdAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
    : '';
  const title = notice.taskTitle || `Task ${notice.taskId ?? ''}`.trim();
  const content = notice.content || '';
  const replyToName = String(notice.replyToAuthorName ?? notice.ReplyToAuthorName ?? "").trim();
  const replyToIdRaw = notice.replyToCommentId ?? notice.ReplyToCommentId;
  const replyToId =
    replyToIdRaw != null && replyToIdRaw !== "" && !Number.isNaN(Number(replyToIdRaw))
      ? String(replyToIdRaw)
      : null;
  const contentLooksReply = /\[reply\s+to\s+#\d+\]/i.test(String(content));
  const isReplyNotice =
    contentLooksReply || !!replyToName || (replyToId != null && Number(replyToId) > 0);

  if (isReplyNotice) {
    const fromContentId = extractReplyTargetIdFromNoticeContent(content);
    const name = String(notice.createdByName ?? notice.CreatedByName ?? "").trim() || "Unknown";
    const replyTo =
      replyToName ||
      (replyToId && Number(replyToId) > 0 ? `#${replyToId}` : null) ||
      (fromContentId ? `#${fromContentId}` : "…");
    const body = stripReplyPrefixFromNotice(content);
    return `${name} Reply to ${replyTo}: ${body}`.trim();
  }

  const typeLabel = normalizeNoticeType(
    notice.commentType ?? notice.CommentType ?? notice.type ?? notice.Type,
    content
  );
  // 类型紧跟时间，便于扫读；纯 Notice 类仍不重复展示
  const typePart = typeLabel && typeLabel !== "Notice" ? `[${typeLabel}] ` : "";
  return `[${datePart}] ${typePart}${title} ${content}`.trim();
}

type TaskNoticeItem = {
  taskId: number | null;
  notificationContext: string;
};

const Home:React.FC = () => {
  const history = useHistory()

  const [dataInBox, setDataInBox] = useState([])
  const [typeOfTable, setTypeOfTable] = useState<number>(0)
  const [dataOfOrder, setDataOfOrder] = useState<any>([])
  const [systemNotifyMessages, setSystemNotifyMessages] = useState<any>([])
  const [taskNotifyMessages, setTaskNotifyMessages] = useState<TaskNoticeItem[]>([])
  const [salesOrderTableVisible, setSalesOrderTableVisible] = useState<boolean>(true)  

  useEffect(() => {
    let mounted = true

    const loadDashboard = async () => {
      try {
        const res: any = await getAllOrderRequest()
      const Normal = dataTransfer('New', res.data.data, 1)
      const Online = dataTransfer('Online', res.data.data, 2)
      const Approved = dataTransfer('Approved', res.data.data, 2)
      const InProduction = dataTransfer('Production', res.data.data, 10)
      const Warehouse = dataTransfer('Warehouse', res.data.data, 11)
      const Dispatched = dataTransfer('Dispatched', res.data.data, 15)
      const PaymentReceived = dataTransfer('Paid', res.data.data, 16)
        if (mounted) {
      setDataOfOrder((prevState: any) => [...prevState, Normal, Online, Approved, InProduction, Warehouse, Dispatched, PaymentReceived])
        }
      } catch (error) {
        console.error('Failed to load orders for dashboard', error)
      }

      try {
        // ============================================
        // 【必要更改】Notice Board 404 错误处理
        // ============================================
        // 原因：TaskComment/GetRecentNotices API 在某些情况下返回 404（如没有公告），
        // 这不应该触发全局错误提示，因为"没有公告"是正常的业务场景
        //
        // 解决方案：
        // 1. 单独处理 TaskComment/GetRecentNotices API 调用
        // 2. 如果返回 404，静默处理（不弹错误框），使用空数组作为默认值
        // 3. 如果返回其他错误（如 500），重新抛出以便外层 catch 处理
        // 4. 如果成功，使用返回的数据；如果 404，使用 fallback 通知
        //
        // 影响范围：首页 Notice Board 显示
        // 必要性：✅ 必须保留 - 改善用户体验，避免不必要的错误提示
        // ============================================
        let taskNoticeData: any[] = []
        try {
          const employeeId = getUserId()
          const employeeIdNum = employeeId ? parseInt(String(employeeId), 10) : 0
          if (Number.isFinite(employeeIdNum) && employeeIdNum > 0) {
            const taskNoticeRes = await ApiRequest({
              otherUrl: 'TaskComment/GetRecentNotices',
              method: 'get',
              params: {
                limit: 5,
                employeeId: employeeIdNum,
              },
              isNotShowSpinnerOverride: true,
              isShowSpinner: false
            })
            taskNoticeData = taskNoticeRes?.data?.data ?? taskNoticeRes?.data ?? []
          }
        } catch (taskError: any) {
          const status = taskError?.response?.status
          if (status === 404) {
            // 404 只当作"没有公告"，不弹错误框
            console.warn('Notice board not found (404), using fallback notifications', taskError)
            taskNoticeData = []
          } else {
            // 其他错误保持原样，重新抛出以便外层 catch 处理
            throw taskError
          }
        }

        // 获取 fallback 通知
        let fallbackNotificationRes: any = null
        try {
          const employeeId = getUserId()
          fallbackNotificationRes = await ApiRequest({
            url: baseUrl + `Notification/GetByEmployee?employeeId=${employeeId}`,
            method: 'get'
          })
        } catch (fallbackError: any) {
          // fallback 请求失败时，只记录日志，不影响主流程
          console.warn('Failed to load fallback notifications', fallbackError)
        }

        const taskMessages: TaskNoticeItem[] = Array.isArray(taskNoticeData)
          ? taskNoticeData
              .map((notice: any) => {
                const taskIdRaw = notice.taskId ?? notice.TaskId;
                const taskId = parseInt(String(taskIdRaw ?? 0), 10);
                return {
                  taskId: Number.isFinite(taskId) && taskId > 0 ? taskId : null,
                  notificationContext: formatNoticeContext(notice),
                  createdAt: notice.createdAt ?? notice.CreatedAt // 保留 createdAt 用于排序
                };
              })
              .sort((a: any, b: any) => {
                const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
                const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
                return dateB - dateA; // 降序，新的在上面
              })
          : []

        // System Notice: 按 notificationId 降序排序（新的在上面）
        const systemMessages = (fallbackNotificationRes?.data?.data ?? [])
          .filter((row: any) => row.isActive)
          .sort((a: any, b: any) => {
            const idA = a.notificationId ?? a.NotificationId ?? 0;
            const idB = b.notificationId ?? b.NotificationId ?? 0;
            return idB - idA; // 降序，新的在上面
          })

        const salesRes: any = await ApiRequest({
          url: baseUrl + 'Salesorder/GetRecentOrderAmount',
          method: 'get'
        })

        if (['26', '38','50'].indexOf(getCookie('id')) === 0) {
          // 假设返回数组前两个值分别是今天和昨天
          const todayAmount = salesRes?.data?.data?.[0]?.toFixed(2)
          const yesterdayAmount = salesRes?.data?.data?.[1]?.toFixed(2)
          if (todayAmount && yesterdayAmount) {
            systemMessages.push({
              notificationContext: `<span style="color:green;font-weight:bold">Today Sold: $${todayAmount}</span> | <span style="color:orange;font-weight:bold">Yesterday Sold: $${yesterdayAmount}</span>`
            })
          }
        }

        if (mounted) {
          setSystemNotifyMessages(systemMessages)
          setTaskNotifyMessages(taskMessages)
        }
      } catch (error) {
        // 这里只处理非 404 的其他错误（如 500、网络错误等）
        console.error('Failed to load notice board data', error)
      }
    }

    loadDashboard()

    return () => {
      mounted = false
    }
  }, [])

  const dataTransfer = (label:string, data:any, statusId:number) => {
    const obj = {
      label: label,
      test: data.filter((res:any) => res.orderStatus?.orderStatusId === statusId),
      box: [
        {
          status: 'have time',
          data: data.filter((res:any) => res.orderStatus?.orderStatusId === statusId).filter((res:any) => res.dueStatus === 0)
        },
        {
          status: 'in Waiting',
          data: data.filter((res:any) => res.orderStatus?.orderStatusId === statusId).filter((res:any) => res.dueStatus === 1)
        },
        {
          status: 'finished',
          data: data.filter((res:any) => res.orderStatus?.orderStatusId === statusId).filter((res:any) => res.dueStatus === 3)
        },
        {
          status: 'urgent',
          data: data.filter((res:any) => res.orderStatus?.orderStatusId === statusId).filter((res:any) => res.dueStatus === 2)
        },
      ]
    }
    return obj
  }

  const tableChangeHandler = (data:any) => {
    const newData = data.map((res:any) => {
      // console.log(res)
      const obj = {
        customer: res.customer.company,
        product: res.orderProduct.map((product:any) => {
          const productObj = {
            name: product.product.productName,
            quantity: product.quantity,
            price: product.price
          }
          return productObj
        }),
        option: res.orderOption.map((option:any) => {
          const optionObj = {
            optionName: option.option.optionName,
            price: option.price
          }
          return optionObj
        }),
        totalPrice: res.totalPrice,
        createdAt: res.createdAt.slice(0, 10),
        requiredDate: res.requiredDate.slice(0, 10)
      }
      return obj
    })
    setSalesOrderTableVisible(false)
    setDataInBox(newData)
    // console.log(newData,'new')
  }

  return (
    <div>
      <dataSend.Provider value={{dataOfTable: dataInBox, changeHandler: tableChangeHandler}}>
        <div>
          <Row style={{ height: '400px' }}>
            <Col span={12}>
              <Task data={dataOfOrder} />
            </Col>
            <Col span={12}>
              <div className="notice-board" onClick={() => { setSalesOrderTableVisible(true) }}>
                <div className="notice-header">
                  Notice Board
                </div>
                <div className="notice-content split-notice-content">
                  <div className="notice-section">
                    <div className="notice-section-title">System Notice</div>
                    <div className="notice-section-body">
                      {systemNotifyMessages.length ? (
                        systemNotifyMessages.map((row: any, i: any) => (
                          <p key={`system-${i}`} dangerouslySetInnerHTML={{ __html: row.notificationContext }} />
                        ))
                      ) : (
                        <p className="notice-empty">No system notices</p>
                      )}
                    </div>
                  </div>
                  <div className="notice-section">
                    <div className="notice-section-title">Task Notice</div>
                    <div className="notice-section-body">
                      {taskNotifyMessages.length ? (
                        taskNotifyMessages.map((row, i) => (
                          <p
                            key={`task-${row.taskId ?? i}-${i}`}
                            className={row.taskId ? 'notice-task-link' : undefined}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (row.taskId) {
                                history.push(`/tasks/detail/${row.taskId}`);
                              }
                            }}
                          >
                            {row.notificationContext}
                          </p>
                        ))
                      ) : (
                        <p className="notice-empty">No task notices</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          {salesOrderTableVisible&&< AwaitingDispatchList userId = {getUserId()} />}
          {!salesOrderTableVisible&&<Row style={{marginTop: '10px'}}>
            <Col span={24}>
              <DashboardTable tableChoice={typeOfTable}/>
            </Col>
          </Row>}
        </div>
      </dataSend.Provider>
      {/*</div>*/}
    </div>
  )
}

const DashboardTable = (props:{tableChoice:number}) => {
  const DataSend = useContext<any>(dataSend)

  //  const TableHeader1 = ['Order number', 'Customer', 'Product','Price', 'Order date', 'Recive Date']

  // console.log(DataSend.dataOfTable)

  //  const data = DataSend.dataOfTable.map((data:any, i:number) => {
  //    console.log(data, 'from table 1')
  //    return(
  //      <div>
  //         <div>this is type {DataSend.type} Table</div>
  //         <div>{data.order}</div>
  //         <div>{data.status}</div>
  //      </div>
  //    )
  //  })

  return (
    <div>
      <Table columns={tableForEmployee} dataSource={DataSend.dataOfTable} pagination={{ pageSize: 10 }}/>
    </div>
  )
}
const Task = (props:{data:any}) => {
  const taskTable = props.data.map((data:any, index:number) => {
    // console.log(data,'inTable')
    return (
      <Col className="gutter-row" span={3} key={index}>
        <div style={{ padding: '8px 0', textAlign: 'center' }}>
          <label>{data.label}</label>
          <div style={{marginTop: '10px', backgroundColor: 'rgba(153, 153, 153, 1)', borderRadius: '10px', height: '345px', textAlign: 'center', display: 'flex', flexDirection: 'column-reverse', padding: '0px 5px'}}>
            {
              data.box.map((boxData:any, index:number) => {
                // console.log(boxData,boxData.dueStatus)
                return (
                  <Box key={index} data={boxData} />
                )
              })
            }
          </div>
        </div>
      </Col>
    )
  })
  return (
    <div>
      <Row gutter={16} justify="center">
        {taskTable}
      </Row>
    </div>
  )
}

const Box = (props:any) => {
  const boxStyle = {backgroundColor: 'red', lineHeight: '40px', marginBottom: '5px', borderRadius: '10px', color: 'white', cursor: 'pointer'}
  const {status, data} = props.data

  boxStyle.lineHeight = `${40 + 10 * data.length}px`

  if (data.length > 4) {
    boxStyle.lineHeight = '80px'
  }

  if (status === 'have time') {
    boxStyle.backgroundColor = 'rgba(21, 96, 2, 1)'
  }
  if (status === 'urgent') {
    boxStyle.backgroundColor = 'rgba(129, 7, 7, 1)'
  }
  if (status === 'in Waiting') {
    boxStyle.backgroundColor = 'rgba(117, 121, 4, 1)'
  }
  if (status === 'finished') {
    boxStyle.backgroundColor = 'rgba(133, 70, 6, 1)'
  }

  return (
    <dataSend.Consumer>
      {(value:any) => <div style={boxStyle} onClick={() => value.changeHandler(data)}>{data.length}</div>}
    </dataSend.Consumer>
  )
}

export default Home
